/**
 * zhanghengh
 * 18/5/31
 * 公式编辑器的搜索树部分，用的包装后的钉耙Tree和Input，如有问题，可以参考钉耙的搜索树的例子
 * 后端是汪建伟
 */
import React, { Component } from "react";
import { Tree, Input } from "@platform/base";
const { TreeNode } = Tree;
import { ajax, toast, isObj, isString, getMultiLang, throttle } from "@platform/api";
import classNames from "classnames";
require("./metaattr.less");

const dataList = []; //自己得到的key和title的数组   这里以后有时间优化一下，这个dataList
// const pathList = []; //已经加载过得节点路径，记录下来，再次展开就不再发请求
export default class MetaAttr extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedKeys: [], //指定展开的节点
            currentIndex: -1, // 当前激活的元数据项下标
            treeData: [], //树数据
            metaNum: 0, // 条目数量
            isAsync: false,
            searchValue: "", //输入input 的值
            autoExpandParent: true, //是否自定展开父节点
            json: {}, //多语
        };
    }
    /**
     * 得需要打开的TreeNode的key得需要打开的TreeNode的key
     * @param {*} key
     * @param {*} tree
     */
    getParentKey = (key, tree) => {
        let parentKey;

        for (let i = 0; i < tree.length; i++) {
            const node = tree[i];
            if (node.children) {
                if (node.children.some(item => item.inputSig === key)) {
                    parentKey = node.inputSig;
                } else if (this.getParentKey(key, node.children)) {
                    parentKey = this.getParentKey(key, node.children);
                }
            }
        }
        return parentKey;
    };
    /**
     * zhanghengh 18/5/31
     * 得到数据数据的{inputSig, displayName}数组的函数
     */

    generateList = data => {
        const { isAsync } = this.state;
        for (let i = 0; i < data.length; i++) {
            const node = data[i];
            let { inputSig, displayName, refcode, refname } = node;
            if (isAsync) {
                displayName = refname + ' ' + refcode;
                inputSig = refcode;
            }
            dataList.push({
                displayName,
                inputSig,
            });
            if (node.children) {
                this.generateList(node.children);
            }
        }
    };

    componentWillMount() {
        const { metaParam, metaUrl } = this.props;
        // 初始化调用getMultiLang方法获取多语
        let callback = (json, bool, LangData) => {
            this.setState({ json, LangData }, () => {
                ajax({
                    url: isString(metaUrl)
                        ? metaUrl
                        : '/nccloud/formula/web/formulaentitytree.do',
                    loading: false,
                    data: isObj(metaParam) ? metaParam : {},
                    success: res => {
                        // if (metaUrl && metaUrl === '/nccloud/riart/print/mdtree.do') {
                        if (metaUrl && metaUrl === '/nccloud/riart/mdtree/threeleveltree.do') {//riart.mdtree.threeleveltree
                            let treeData = res.data.rows || [];
                            this.setState({ treeData, isAsync: true });
                            this.generateList(treeData);
                        } else {
                            this.setState({ treeData: [res.data], isAsync: false });
                            this.generateList([res.data]);
                        }

                    },
                    error: () => {
                        // mock
                        
                        // this.setState({ treeData: mockAttrData, isAsync: false });
                        // this.generateList(mockAttrData);
                        toast({
                            color: 'danger',
                            content: `${this.state.json['formula0010']}`,
                        });
                    },
                });

            });
        };
        getMultiLang({ moduleId: 'container_formulaEditor', callback }); // moduleId为所需加载json文件夹名称前缀
    }

    /**
     * zhanghengh 18/5/31
     * 当打开或关闭树节点触发的方法
     */
    handleExpand = expandedKeys => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    };
    /**
     * @value 搜索的值
     * zhanghengh 18/5/31
     * input onchange 回调
     */
    handleInput = value => {
        const _this = this;
        const { treeData, isAsync } = this.state;
        const expandedKeys = [];
        dataList.forEach(item => {
            const { displayName, inputSig } = item;
            if (value && displayName.toLowerCase().indexOf(value.toLowerCase()) > -1) {
                if (isAsync) {
                    expandedKeys.push(inputSig);
                } else {
                    expandedKeys.push(_this.getParentKey(inputSig, treeData));
                }

            }
        });
        // console.log('handleInput====', expandedKeys)
        const uniqueExpandedKeys = [];
        expandedKeys.forEach(item => {
            if (item && uniqueExpandedKeys.indexOf(item) === -1) {
                uniqueExpandedKeys.push(item);
            }
        });
        // console.log('expandedKeys:',expandedKeys, 'uniqueExpandedKeys', uniqueExpandedKeys)
        this.setState({
            expandedKeys: uniqueExpandedKeys,
            searchValue: value,
            currentIndex: -1,
            autoExpandParent: true,
        }, () => {
            this.clearCheckedState("input");
            this.setMetaNum();
        });
    };
    /**
     * 获取所有过滤匹配上的节点
     */
    getAllFilterNodes = () => {
        const filterList = document.querySelectorAll('.formulaeditor-metaattr-searchable');
        return filterList;
    }
    /**
     * 设置匹配到的节点数
     */
    setMetaNum = () => {
        setTimeout(()=>{
            let metaNum = this.getAllFilterNodes()?.length;
            this.setState({metaNum}, () => {
                // console.log("metaNum", metaNum)
            })
        },500)
    }
    /**
     * 点击按钮 定位查找
     */
    hanlePosition = key => {
        // console.log("定位查找")
        let { currentIndex } = this.state;
        let parentNodes = [];
        const filterList = this.getAllFilterNodes();
        filterList.forEach(item => {
            parentNodes.push(item.parentNode?.parentNode?.parentNode);
        })
        parentNodes.forEach(item => item?.classList.remove("formula-metaattr-filter-checked"));
        // console.log('parentNodes', parentNodes)
        
        let len = filterList.length;
        if(!len) return;
        // 向上查找
        if(key === "up") {
            if(currentIndex === -1 || currentIndex === 0) {
                currentIndex = len - 1;
            } else {
                currentIndex --;
            }
        } else if(key === "down") {
            // 向下查找
            if(currentIndex === len - 1) {
                currentIndex = 0;
            } else {
                currentIndex ++;
            }
        }
        // console.log(parentNodes, currentIndex)
        this.setState({currentIndex}, () => {
            parentNodes[currentIndex]?.classList.add("formula-metaattr-filter-checked");
            parentNodes[currentIndex]?.scrollIntoView({block:'nearest', behavior:'smooth'});
        })
    }
    /**
     * zhanghengh 18/5/31
     * 选择树节点时候的回调
     */
    handleDoubleClick = value => {
        // 添加判断让树的根节点不可以双击赋值 罗敏让加的，说的和nc保持一致
        if (!value.includes('$$formulaTreeRootFlag$$')) {
            this.props.setName(value);
        }
    };
    /**
     * 清空树的选中状态
     */
    clearCheckedState = action => {
        // console.log("action", action)
        let metaattrNodes = document.querySelector(".formulaeditor-search-tree-area");
        let filterCheckedNodes = metaattrNodes.querySelector(".formula-metaattr-filter-checked");
        let defaultCheckedNodes = metaattrNodes.querySelector(".u-tree-node-selected");
        // console.log("defaultCheckedNodes", defaultCheckedNodes)
        filterCheckedNodes?.classList.remove("formula-metaattr-filter-checked");
        // 单击搜索时 匹配上的节点
        if(action === "click") {
            defaultCheckedNodes?.classList.replace("u-tree-node-selected", "formula-metaattr-filter-checked");
        } else if(action === "input") {
            // 搜索内容发生变化 && 匹配上的节点数>0时, 清空已选中节点的状态
            // 如 匹配的节点数 < 0，折叠根节点，不清空选中节点的状态
            defaultCheckedNodes?.classList.remove("u-tree-node-selected");
        }
    }
    /**
     * zhanghengh 18/5/31
     * 选择树节点时候的回调
     */
    handleSelect = (value, event) => {
        // 开启了过滤
        if(!!this.state.searchValue) {
            const currentIndex = parseInt(event.node.selectHandle.children[1]?.children[0]?.dataset?.index);
            currentIndex > -1 && this.setState({currentIndex}, () => this.clearCheckedState("click"))
        }
        this.props.setExplain(event.node.props.explain);
    };

    //加载异步树数据
    loadData = node => {
        const { metaParam, metaUrl } = this.props;
        const { queryCondition = {} } = metaParam;
        const { props = {} } = node;
        const { pos } = props;
        return new Promise(resolve => {
            // if (pathList.includes(pos)) {
            //     resolve();
            //     return;
            // }
            ajax({
                url: metaUrl,
                loading: false,
                data: {
                    queryCondition: {
                        mdclass: queryCondition.mdclass,
                        pid: props.refpk,
                    },
                },
                success: res => {
                    let { treeData } = this.state;
                    let path = pos.split('-');
                    // pathList.push(pos);

                    let set = (data, path) => {
                        path.shift();
                        if (path.length) {
                            if (!data[path[0]].children) {
                                data[path[0]].children = res.data.rows;
                            } else {
                                let children = data[path[0]].children;
                                set(children, path);
                            }
                        }
                    }
                    set(treeData, path);

                    this.setState(treeData);
                    this.generateList(treeData);
                    resolve();
                },
                error: () => {
                    toast({
                        color: 'danger',
                        content: `${this.state.json['formula0010']}`,
                    });
                    resolve();
                },
            });
        });
    }

    createAsyncTree = () => {
        const {
            searchValue,
            expandedKeys,
            autoExpandParent,
            treeData,
        } = this.state;
        // 只给根节点设置一次标记的标志
        // let callNumFlag = true;
        // 需要给根节点加的标记
        // let rootFlag = '';
        // 开启搜索时 单击变量 存储下标
        let dataIndex = -1;
        const loop = (data, isroot) => data.map(item => {
            const { refcode, refname, refpk, children, isleaf } = item;
            let displayName = refname + ' ' + refcode;
            const _index = displayName.indexOf(searchValue.toLowerCase());
            if(!!searchValue && _index > -1  && !isroot) {
                dataIndex ++;
            } 
            const beforeStr = displayName.substr(0, _index);
            const searchStr = displayName.substr(_index, searchValue.length);
            const afterStr = displayName.substr(_index + searchValue.length);
            const title =
            (_index > -1 && !isroot) ? (
                    <span data-index={dataIndex}>
                        {beforeStr}
                        <span className="formulaeditor-metaattr-searchable">
                            {searchStr}
                        </span>
                        {afterStr}
                    </span>
                ) : (
                    <span>{displayName}</span>
                );

            // if (!isleaf) {
            //     // 只对根节点设置一次，其他下级节点不生效
            //     // 添加判断让树的根节点不可以双击赋值 罗敏让加的，说的和nc保持一致
            //     rootFlag = '$$formulaTreeRootFlag$$';
            //     // callNumFlag = false;
            // } else {
            //     rootFlag = '';
            // }
            if (Array.isArray(children) && children[0]) {
                return (
                    <TreeNode
                        key={refcode}
                        title={title}
                        explain={refname}
                        isLeaf={isleaf}
                        refpk={refpk}
                        icon={<i className={classNames("iconfont", expandedKeys.includes(refcode) ? "icon-wenjianjiadakai" : "icon-wenjianjia")} style={{color: '#f2b224'}}/>}
                    >
                        {loop(children)}
                    </TreeNode>
                );
            }
            return (
                <TreeNode key={refcode} title={title} explain={refname} isLeaf={isleaf} refpk={refpk}  icon={<i className="tree-dian" />} />
            );
        });
        return (
            <Tree
                onDoubleClick={this.handleDoubleClick}
                onSelect={this.handleSelect}
                onExpand={this.handleExpand}
                showIcon
                // focusable
                showLine={true}
                expandedKeys={expandedKeys}
                autoExpandParent={autoExpandParent}
                loadData={this.loadData}
            >
                {loop(treeData, true)}
            </Tree>
        );
    }

    createSyncTree = () => {
        let {
            searchValue,
            expandedKeys,
            autoExpandParent,
            treeData,
        } = this.state;
        // 只给根节点设置一次标记的标志
        let callNumFlag = true;
        // 需要给根节点加的标记
        let rootFlag = '';
        // 开启搜索时 单击变量 存储下标
        let dataIndex = -1;
        // console.log("treeData", treeData)
        const loop = (data, isroot) => data.map(item => {
            // console.log('item', item)
            const { displayName, inputSig, children, hintMsg } = item;
            const _index = displayName.indexOf(searchValue.toLowerCase());
            if(!!searchValue && _index > -1 && !isroot) {
                dataIndex ++;
            }
            const beforeStr = displayName.substr(0, _index);
            const searchStr = displayName.substr(_index, searchValue.length);
            const afterStr = displayName.substr(_index + searchValue.length);
            // 根节点不参与搜索
            const title =
            (_index > -1 && !isroot) ? (
                    <span data-index={dataIndex}>
                        {beforeStr}
                        <span className="formulaeditor-metaattr-searchable">
                            {searchStr}
                        </span>
                        {afterStr}
                    </span>
                ) : (
                    <span>{displayName}</span>
                );

            if (callNumFlag&&isroot) {
                // 只对根节点设置一次，其他下级节点不生效
                // 添加判断让树的根节点不可以双击赋值 罗敏让加的，说的和nc保持一致
                rootFlag = `$$formulaTreeRootFlag$$`;
                callNumFlag = false;
                // 开启搜索并匹配到第一层节点时，展开根节点
                // console.log(expandedKeys, inputSig)
                if(searchValue && expandedKeys?.length === 1 && expandedKeys.includes(inputSig)) { 
                    expandedKeys[0] = inputSig+rootFlag;
                }
            } else {
                rootFlag = "";
            }

            if (Array.isArray(children) && children[0]) {
                // console.log('expandedKeys', expandedKeys,inputSig,expandedKeys.includes(inputSig))

                return (
                    <TreeNode
                        key={inputSig + rootFlag}
                        title={title}
                        explain={hintMsg}
                        icon={<i className={classNames("iconfont", expandedKeys.includes(inputSig) ? "icon-wenjianjiadakai" : "icon-wenjianjia")} style={{color: '#f2b224'}}/>}
                    >
                        {loop(children)}
                    </TreeNode>
                );
            }
            return (
                <TreeNode key={inputSig} title={title} explain={hintMsg} icon={<i className="tree-dian" />} />
            );
        });
        return (
            <Tree
                onDoubleClick={this.handleDoubleClick}
                onSelect={this.handleSelect}
                onExpand={this.handleExpand}
                showIcon
                // focusable
                showLine={true}
                expandedKeys={expandedKeys}
                autoExpandParent={autoExpandParent}
            >
                {loop(treeData,true)}
            </Tree>
        );
    }

    /**
     * zhanghengh 18/5/31 
     * 创建全部区域的方法
     */
    _createAll = () => {
        const { json, isAsync, searchValue, metaNum, currentIndex } = this.state;
        const { tabPaneHeight } = this.props;
        return (
            <div className="search-tree-area formulaeditor-search-tree-area">
                <Input
                    style={{ width: '100%' }}
                    placeholder={json['formula0017']}
                    value={searchValue}
                    onChange={this.handleInput}
                    type="search"
                />
                {!!searchValue&&metaNum?
                    <div className="formulaeditor-metaattr-num">
                        <span>{currentIndex+1}/{metaNum}</span> 
                        <i className="iconfont icon-xiajiantou" onClick={() =>this.hanlePosition("down")}></i>
                        <i className="iconfont icon-shangjiantou" onClick={() => this.hanlePosition("up")}></i>
                    </div>
                :''}
                <div className="tree-content" style={{ height: 'calc(100% - 28px)', paddingTop: '10px'}}>
                    {isAsync ? this.createAsyncTree() : this.createSyncTree()}
                </div>
            </div>
        );
    };
    render() {
        return this._createAll();
    }
}
